export default {"src":"/_next/static/media/COPY_GREY.39404b5a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};